<template>
    <div class="field">
        <label class="label">
            {{ label }}
            <span class="has-text-danger" v-if="required">*</span>
        </label>
        <div class="control" v-if="value">
            <div class="notification is-light p-2 mb-0 is-flex is-align-items-center is-justify-content-space-between">
                <span>{{ optionLabel(value) }}</span>
                <button type="button" class="button is-small is-danger is-light" @click="clear">Промени</button>
            </div>
        </div>
        <div v-else>
            <div class="control" :class="{'is-loading': loading}">
                <input class="input" type="text" :placeholder="placeholder" :disabled="disabled"
                       :value="query" @input="handleInput">
            </div>
            <div class="els-results" v-if="!disabled">
                <a class="panel-block" v-for="item in items" :key="item.id" @click="choose(item)">
                    {{ optionLabel(item) }}
                </a>
                <p class="help is-danger" v-if="error">{{ error }}</p>
                <p class="help" v-else-if="!loading && !items.length">{{ emptyText }}</p>
                <p class="help" v-else-if="total > items.length">
                    Прикажани се {{ items.length }} од {{ total }} резултати - прецизирајте го пребарувањето.
                </p>
            </div>
            <p class="help" v-if="disabled">{{ disabledText }}</p>
        </div>
    </div>
</template>

<script>
    import {elsError, elsSearch} from "../../../api/els";

    export default {
        name: "ElsSearchSelect",
        props: {
            // Избраниот запис ({id, name, ...}) или null.
            value: {type: Object, default: null},
            label: String,
            placeholder: String,
            // Патека до ЕЛС пребарувањето, пр. "/els/places".
            url: {type: String, required: true},
            disabled: Boolean,
            disabledText: {type: String, default: ""},
            required: Boolean,
            // Кандидати од prefill - се прикажуваат додека нема пребарување.
            candidates: {type: Array, default: () => []},
            emptyText: {type: String, default: "Нема пронајдено резултати"},
            optionLabel: {type: Function, default: (item) => item.name}
        },
        data() {
            return {
                query: "",
                items: this.candidates.slice(),
                total: this.candidates.length,
                loading: false,
                error: null,
                timeout: null,
                cancel: null
            }
        },
        methods: {
            handleInput(e) {
                const start = e.target.selectionStart;
                this.query = this.$l2c(e.target.value);
                this.$nextTick(() => {
                    e.target.selectionStart = e.target.selectionEnd = start;
                });
                this.search();
            },
            choose(item) {
                this.$emit("input", item);
            },
            clear() {
                this.$emit("input", null);
                this.query = "";
                this.items = this.candidates.slice();
                this.total = this.candidates.length;
                this.search();
            },
            search() {
                if (this.disabled) return;
                if (this.cancel) this.cancel.cancel();
                clearTimeout(this.timeout);
                this.loading = true;
                this.error = null;
                this.timeout = setTimeout(() => {
                    this.cancel = this.$http.CancelToken.source();
                    elsSearch(this.url, this.query, {cancelToken: this.cancel.token})
                        .then(res => {
                            if (!res) return; // откажано барање
                            this.items = res.items;
                            this.total = res.total;
                            this.loading = false;
                        })
                        .catch(e => {
                            if (this.$http.isCancel(e)) return;
                            this.items = [];
                            this.total = 0;
                            this.loading = false;
                            this.error = elsError(e);
                        });
                }, 300);
            }
        },
        mounted() {
            if (!this.value && !this.items.length) this.search();
        },
        beforeDestroy() {
            clearTimeout(this.timeout);
            if (this.cancel) this.cancel.cancel();
        }
    }
</script>

<style scoped>
    .els-results {
        max-height: 190px;
        overflow-y: auto;
    }

    .els-results .panel-block {
        cursor: pointer;
    }
</style>
